import { NumberFormatBase } from 'react-number-format';
import Select from 'react-select';
import endpoints from '../../config/endpoints';
import { ReactElement, useEffect, useState } from 'react';
import { useDispatch } from "react-redux";
import globalEnum from '../../enums/globalEnum';
import { setLoading } from "../../services/reducers/homeSlice";
import restApi from "../../services/restApi";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import tools from '../../utils/tools';
import { Sidebar } from '../Layout/Sidebar';
import product from '../Product';
import productAccess from './ProductAccess';
import ProductAccess from './ProductAccess';

const RoleMange = () => {
  const dispatch = useDispatch();
  const { id: paramId } = useParams();
  const navigate= useNavigate()
  const [cars,setCars]=useState([])
  const [brands, setBrands] = useState([]);
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [form, setForm] = useState<any>({
    products: []
  });

  const send = async () => {
    dispatch(setLoading(true));
    
    const res = await restApi(endpoints.role.basic + (paramId || ''), true).post({
      title: form?.title,
      description: form?.description,
      maxBuyAmount: form?.maxBuyAmount,
    })

    await restApi(endpoints.role.access + res.data?.id).post({
      cars: form?.selectedCars,
      brands: form?.selectedBrands,
      categories: form?.selectedCategories,
      products: form?.products
    })
    
    if(res.code == 200){
      Swal.fire({
        title: 'موفق',
        text: `نقش  با موفقیت ${paramId ? 'ویرایش' : 'افزودن'} شد`,
        icon: 'success',
        confirmButtonText: 'متوجه شدم'
      })
    } else {
      Swal.fire({
        title: 'ناموفق',
        text: res?.data,
        icon: 'error',
        confirmButtonText: 'متوجه شدم'
      })
    }
    
    dispatch(setLoading(false));
  }

  const fetchItem = async () => {
    dispatch(setLoading(true))
    if (paramId) {
      const res = await restApi(endpoints.role.single + paramId, true).get();

      if (res.code == 200) {
        setForm({
          title: res.data?.title,
          description: res.data?.description,
          maxBuyAmount: res.data?.maxBuyAmount,
          products: res.data?.accesses?.filter(e => e.entityType == globalEnum.entityType.product).map(e => ({
            productId: e.productId,
            status: e.status,
            price: e.price,
            unitType: e.unitType,
            allowUnitTypeFallback: e.allowUnitTypeFallback
          })),
          selectedCars: res.data?.accesses?.filter(e => e.entityType == globalEnum.entityType.car).map(e => e.entityId.toString()),
          selectedCategories: res.data?.accesses?.filter(e => e.entityType == globalEnum.entityType.category).map(e => e.entityId.toString()),
          selectedBrands: res.data?.accesses?.filter(e => e.entityType == globalEnum.entityType.brand).map(e => e.entityId.toString())
        });
      }
    }
    const result = await Promise.all([
      restApi(endpoints.car.index, true).get(),
      restApi(endpoints.brand.index, true).get(),
      restApi(endpoints.category.index, true).get(),
      restApi(endpoints.product.index, true).get(),
    ])

      setCars(result[0].data)
      setBrands(result[1].data)
      setCategories(result[2].data)
      setProducts(result[3].data)

    dispatch(setLoading(false))
  }

  useEffect(() => {
    fetchItem()
  }, [])
  return (
    <>
      <body className="dashboardBody">
      <Sidebar />
      <main className="dashBoardMain main">
        <div className="addInfoHeader">
          <span className="dashboardHeader keepRight clickable" onClick={send}>
           ارسال
          </span>
          <span>
            <h1 className="sideBarTitle">بازگشت به صفحه لیست نقش </h1>
             <h1 className="dashBoardTitle">{paramId ? 'ویرایش' : 'افزودن'} نقش </h1>
          </span>
          <i className="backAdd clickable" onClick={() => navigate("/car/")}></i>
        </div>
        <section className="bottomSection">
          <h1 className="dashBoardTitle">اطلاعات نقش </h1>
          <form className="addInfo">
            <label className="sideBarTitle" htmlFor="infoTitle">عنوان</label>
            <input className="addInput" id="infoTitle" onChange={(input: any) => setForm(prevState => ({ ...prevState, title: input.target.value}))} value={form?.title}/>
            <label className="sideBarTitle" htmlFor="infoTitle">سقف خرید</label>
            <NumberFormatBase className="addInput" id="infoTitle" onValueChange={(values) => setForm(prevState => ({ ...prevState, maxBuyAmount: values.value}))} value={form?.maxBuyAmount ?? ''} format={(str) => (str ? tools.formatPrice(Number(str)) : '')}/>
            <label className="sideBarTitle" htmlFor="infoTitle">توضیحات</label>
            <input className="addInput" id="infoTitle" onChange={(input: any) => setForm(prevState => ({ ...prevState, description: input.target.value}))} value={form?.description}/>
            </form>
        </section>
        <ProductAccess categories={categories} cars={cars} brands={brands} form={form} setForm={setForm} products={products} />
      </main>
      </body>
    </>
  )
}
export default RoleMange;